import React from 'react'
import Team1 from '../components/Team1/Team1'
import Team2 from '../components/Team2/Team2'

const Teams = () => {
  return (
    <div className='teams'>
      <Team1/>
      <Team2/>
    </div>
  )
}

export default Teams